export const EDIT_BUSINESS = 'EDIT_BUSINESS';
export const GET_BUSINESS = 'GET_BUSINESS';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const COLLABORATION_RESPONSE = 'COLLABORATION_RESPONSE';
export const EDIT_LOGO = 'EDIT_LOGO';
export const ADD_BUSINESSUSER = 'ADD_BUSINESSUSER';
export const REORDER_SURVEYTREE = 'REORDER_SURVEYTREE';
export const SURVEYTREE_SELECTION = 'SURVEYTREE_SELECTION';